import React from 'react'
import moment from 'moment'

import App from './App'
import Page from './Page'

import Home from './pages/Home'
import Trivia from './pages/Trivia'
import Form from './pages/Form'
import Ranking from './pages/Ranking'
import RankingHome from './pages/RankingHome'
import NextWeek from './pages/NextWeek'
import Modal from './components/Modal'
import { LANGUAGES, I18N } from './config'

import i18next, { t } from 'i18next'
import * as es from './locales/es.json'
import * as en from './locales/en.json'

import 'moment/locale/es'
import 'moment/locale/en-gb'

const Root = ({ match }) => {
  const language = match.params.language || 'es'
  const existLanguage = LANGUAGES.indexOf(language) >= 0

  moment.locale(I18N[language])

  i18next.init({
    lng: existLanguage ? language : 'es', // 'en' | 'es'
    resources: {
      en: {
        translation: en
      },
      es: {
        translation: es
      }
    }
  })

  return existLanguage ? (
    <App language={language}>
      <Page>
        <Home />
        <Trivia />
        <Ranking />
        <Form />
        <NextWeek />
        <RankingHome />
      </Page>
      <Modal />
    </App>
  ) : (
    <div
      className="flex-align-center"
      style={{
        height: '100vh',
        fontSize: 32,
        color: '#fff',
        padding: 30,
        textAlign: 'center'
      }}
    >
      {t('error.language')}
    </div>
  )
}

export default Root



// WEBPACK FOOTER //
// ./src/Root.js